import React, { Component } from 'react';
import { Route, Redirect, withRouter } from "react-router-dom";
import { connect } from 'react-redux';

import { USERTYPE } from './app/common/constants.js'

class PrivateRoute extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login : this.props.login ? this.props.login : false,
      userType : this.props.userType ? this.props.userType : USERTYPE.GENERAL.toString(),
    };
  }

  componentDidMount() {
      if(!this.state.login){
        this.props.dispatch({type: "Logout"});
      }
  }

  render() {
    const { login } = this.state;
    if(!login) {
      return <Redirect to={{ pathname: '/', state: { from: this.props.location } }} />
    } else {
      if(!this.props.permission || this.props.permission.filter(p => p === this.state.userType).length > 0) {
        return (
          <Route exact path={this.props.path} component={this.props.component} />
        )
      } else {
        if(this.props.permission.filter(p => p === USERTYPE.GENERAL).length > 0) {
          return <Redirect to={{ pathname: '/', state: { from: this.props.location } }} />
        } else {
          return <Redirect to={{ pathname: '/admin', state: { from: this.props.location } }} />
        }
      }
    }
  }
}

const mapStateToProps = store => {
    return {
        login: store.login.login,
        userType: store.login.user ? store.login.user.type : USERTYPE.GENERAL.toString()
    }
};

const connectedPrivateRoute = connect(mapStateToProps)(withRouter(PrivateRoute));
export { connectedPrivateRoute as PrivateRoute };